import React from 'react';
import Layout from '../../Shared/Layout/LayoutAdmin';
import Row from 'react-bootstrap/Row';
import AlertDismissible from '../../Shared/Components/AlertDismissible';
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';
import { Link, usePage } from '@inertiajs/inertia-react';
import { formatMoneyMXN as formatMoney, formatPremiumMin, formatPremiumMax } from '../../utils/formatters';
import { t } from '../../i18n/labels';
import { Inertia } from '@inertiajs/inertia';

const List = ({ items, latest_update }) => {
    const { flash } = usePage().props;
    const data = items.data;

    const handleDelete = (id) => {
        if (confirm('¿Seguro que deseas eliminar este nivel?')) {
            Inertia.delete(route('advisor_commission_tiers.destroy', id));
        }
    };

    return (
        <Row>
            {flash.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="p-7">
                <Breadcrumbs currentPath="/admin/master_data/advisor-commission-tiers" />
            </span>
            <div className="card card-flush h-md-100">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Tabla de Comisiones (Asesores)</span>
                        <span className="text-gray-400 mt-1 fw-semibold fs-6">Última Actualización: {latest_update}</span>
                    </h3>
                    <div className="card-toolbar">
                        <Link href={route('advisor_commission_tiers.create')} className='me-3 btn btn-sm btn-primary'>Agregar Nivel</Link>
                    </div>
                </div>
                <div className="card-body pt-6">
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="p-0 pb-3 text-start">CATEGORÍA</th>
                                    <th className="p-0 pb-3 text-start">{t('advisorCommissionTiers.min_monthly_premium')}</th>
                                    <th className="p-0 pb-3 text-start">{t('advisorCommissionTiers.max_monthly_premium')}</th>
                                    <th className="p-0 pb-3 text-start">% COMISIÓN</th>
                                    <th className="p-0 pb-3 text-start">% ADICIONAL</th>
                                    <th className="p-0 pb-3 text-end"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 && (
                                    <tr><td colSpan="6" className="px-6 py-3 text-center text-gray-800 fw-bold">No hay datos.</td></tr>
                                )}
                                {data.map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.name}</td>
                                        <td>{formatPremiumMin(item.min_monthly_premium)}</td>
                                        <td>{formatPremiumMax(item.max_monthly_premium)}</td>
                                        <td>{item.commission_percent}%</td>
                                        <td>{item.additional_percent}%</td>
                                        <td className='text-end'>
                                            <Link href={route('advisor_commission_tiers.edit', item.id)} className='btn btn-sm btn-light me-2'>Editar</Link>
                                            <button
                                                className='btn btn-sm btn-danger'
                                                onClick={() => handleDelete(item.id)}
                                                type="button"
                                            >
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Row>
    );
};

List.layout = page => <Layout children={page} title="Tabla Comisiones" />;
export default List;
